import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-media-videos',
  templateUrl: './media-videos.component.html',
  styleUrl: './media-videos.component.scss',
})
export class MediaVideosComponent {
  videos = [
    {
      id: 'dfdGUaUQvEs',
      title: 'المنطقة الإستثمارية بالصف',
      thumbnail: '../../../assets/media/video1.jpg',
    },
    {
      id: '9V6SLhyMgsg',
      title: 'المناطق الحرة المصرية',
      thumbnail: '../../../assets/media/video2.jpg',
    },
  ];

  selectedVideoUrl: SafeResourceUrl | null = null;
  isModalOpen = false;

  constructor(private sanitizer: DomSanitizer) {}

  openVideo(videoId: string) {
    const url = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectedVideoUrl = null;
  }
}
